import BaseApi from '@/api/Base/BaseApi'
import {
  CreateDatasetNodeFromResultPayload,
  CreatePreprocessingResultNodePayload,
  GetAllPreprocessingItemsResponse,
  GetPreprocessingItemsResponse,
  GetPreprocessingResultResponse,
  GetPreprocessingStatusResponse,
  PreprocessingResultNodeInfo,
  UpdatePreprocessingResultNodePayload
} from '@/api/PreprocessingResultNode/types'
import { CommonListPayload, DatasetNodeInfo } from '@/api/DatasetNode/types'

const ROOT = '/preprocessing-result'

const defaultPaginationOptions = {
  itemsPerPage: 40,
  page: 0,
  sortDir: 'desc',
  sortKey: 'createdAt',
}

// TODO: common util?
const generatePaginationParams = (options?: CommonListPayload) => {
  const { page, itemsPerPage, sortKey, sortDir } = options ?? defaultPaginationOptions
  return {
    page,
    num_per_page: itemsPerPage,
    sort_key: sortKey,
    sort_dir: sortDir,
  }
}

export default class PreprocessingResultNodeApi extends BaseApi {
  createPreprocessingResultNode(payload: CreatePreprocessingResultNodePayload) {
    const { projectId, ...rest } = payload
    return this.agent.post(`/project/${projectId}${ROOT}/create`, rest)
  }

  getPreprocessingResultNodeDetail(preprocessingResultNodeId: string) {
    return this.agent.get<PreprocessingResultNodeInfo>(`${ROOT}/${preprocessingResultNodeId}`)
  }

  updatePreprocessingResultNode(payload: UpdatePreprocessingResultNodePayload) {
    const { preprocessingResultNodeId, name, ...rest } = payload
    return this.agent.put<PreprocessingResultNodeInfo>(`${ROOT}/${preprocessingResultNodeId}`, { ...rest, name: name?.trim() })
  }

  deletePreprocessingResultNode(preprocessingResultNodeId: string) {
    return this.agent.delete(`${ROOT}/${preprocessingResultNodeId}`)
  }

  startPreprocessing(preprocessingResultNodeId: string) {
    return this.agent.post<GetPreprocessingStatusResponse>(`${ROOT}/${preprocessingResultNodeId}/preprocessing`)
  }

  stopPreprocessing(preprocessingResultNodeId: string) {
    return this.agent.post<GetPreprocessingStatusResponse>(`${ROOT}/${preprocessingResultNodeId}/preprocessing/stop`)
  }

  getPreprocessingStatus(preprocessingResultNodeId: string) {
    return this.agent.get<GetPreprocessingStatusResponse>(`${ROOT}/${preprocessingResultNodeId}/preprocessing/status`)
  }

  getPreprocessingResult(preprocessingResultNodeId: string) {
    return this.agent.get<GetPreprocessingResultResponse>(`${ROOT}/${preprocessingResultNodeId}/preprocessing`)
  }

  /**
   * @deprecated : use getAllPreprocessingItems instead
   */
  getPreprocessingResultItems(preprocessingResultNodeId: string, options?: CommonListPayload) {
    const { itemsPerPage, page, sortDir, sortKey } = options ?? defaultPaginationOptions
    return this.agent.get<GetPreprocessingItemsResponse>(`${ROOT}/${preprocessingResultNodeId}/items`, {
      params: {
        page,
        num_per_page: itemsPerPage,
        sort_key: sortKey,
        sort_dir: sortDir,
      },
    })
  }

  /**
   * @deprecated : use getAllPreprocessingItems instead
   */
  getOriginalItems(preprocessingResultNodeId: string, options?: CommonListPayload) {
    const params = generatePaginationParams(options)
    return this.agent.get<GetPreprocessingItemsResponse>(`${ROOT}/${preprocessingResultNodeId}/original-items`, {
      params,
    })
  }

  getAllPreprocessingItems(preprocessingResultNodeId: string, options?: CommonListPayload) {
    const { itemsPerPage, page, sortDir, sortKey } = options ?? defaultPaginationOptions

    return this.agent.get<GetAllPreprocessingItemsResponse>(`${ROOT}/${preprocessingResultNodeId}/all-items`, {
      params: {
        page,
        num_per_page: itemsPerPage,
        sort_key: sortKey,
        sort_dir: sortDir,
      },
    })
  }

  createDatasetNodeFromResult(payload: CreateDatasetNodeFromResultPayload) {
    const { preprocessingResultNodeId, ...rest } = payload
    return this.agent.post<DatasetNodeInfo>(`${ROOT}/${preprocessingResultNodeId}/create-dataset`, rest)
  }
}
